import React, { useState } from 'react'
import booklistStyle from './booklistinfo.module.css'
require('typeface-poppins')


export default function BooklistInfo({ authorbookdata }) {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${booklistStyle.contactAccordion} accordion mb-3`} id="ContactInfo">
                <div className={`${booklistStyle.contactMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${booklistStyle.contactbuttonItem} ${booklistStyle.booklistBeforebg} accordion-button ${openIndex === 0 ? '' : `${booklistStyle.booklistbgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            Book List
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ContactInfo">
                        <div className={`${booklistStyle.moreBody} accordion-body`}>
                            <div className={booklistStyle.infoWrapper}>
                                <div className={booklistStyle.headInfo}>
                                    <h6> Title/ISBN </h6>
                                    <h6> Price </h6>
                                </div>
                                {authorbookdata.map((book, index) => (
                                    <div key={index} className={`${booklistStyle.dataInfo} ${index % 2 === 0 ? booklistStyle.oddColor : booklistStyle.evenColor}`}>
                                        <div className={`${booklistStyle.isbnInfo} w-100`}>
                                            <h4> {book.title} </h4>
                                            <h4> {book.isbn} </h4>
                                        </div>
                                        <div className={`${booklistStyle.listPrice} w-100 text-end`}>
                                            <p> ${book.price} </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}